import React, { useState } from "react";
import { Link } from "react-router-dom";
import shape from "../../images/shapes/footerShape2.png";
import JjfLogo from "../../images/jjf-india-new-logo.png";

const Footer = (props) => {
  // const location = useLocation();
  // const [pageTitle, setPageTitle] = useState("Home");

  const ClickHandler = (newTitle) => {
    window.scrollTo(10, 0);
    // setPageTitle(newTitle);
  };

  const [email, setEmail] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const validateForm = () => {
    const newErrors = {};

    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      newErrors.email = "Email ID is required.";
    } else if (trimmedEmail.length > 254) {
      newErrors.email = "Email ID must be 254 characters or fewer.";
    } else if (
      !/^(?=.*[a-zA-Z])[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(
        trimmedEmail
      )
    ) {
      newErrors.email = "Please enter a valid Email ID.";
    }

    if (!isAgreed) {
      newErrors.isAgreed = "You must agree to the terms before subscribing.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      // await fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/newsletter`, {
      await fetch(`https://marscms-api.mini91.com/api/newsletter`, {
        method: "POST",
        body: JSON.stringify({
          email: email,
          site: "6798f689e5b0d99195ac3eb8",
        }),
        headers: { "Content-Type": "application/json" },
      })
        .then(async (response) => {
          console.log(response.status);
          if (response?.ok) {
            setSuccessMessage("Thank you for subscribing to our newsletter!");
            setEmail("");
            setIsAgreed(false);
            setErrors({});
            setTimeout(() => setSuccessMessage(""), 5000);
          } else {
            setSuccessMessage("");
            let error = await response.json();
            setErrors({ submit: error.error });
          }
        })
        .then(({ status, body }) => {})
        .catch((error) => {
          // Handle error
          console.log(error);
        });
    }
  };

  // useEffect(() => {
  //   const path = location.pathname;
  //   switch (path) {
  //     case "/":
  //       setPageTitle("Home");
  //       break;
  //     case "/who-we-are":
  //       setPageTitle("Who We Are");
  //       break;
  //     case "/our-journey":
  //       setPageTitle("Our Journey");
  //       break;
  //     case "/leadership-team":
  //       setPageTitle("Leadership Team");
  //       break;
  //     case "/success-stories":
  //       setPageTitle("Success Stories");
  //       break;
  //     case "/testimonials":
  //       setPageTitle("Testimonials");
  //       break;
  //     case "/achievements":
  //       setPageTitle("Achievements");
  //       break;
  //     case "/contact-us":
  //       setPageTitle("Contact Us");
  //       break;
  //     case "/legal-documents":
  //       setPageTitle("Legal Documents");
  //       break;
  //     case "/privacy-policy":
  //       setPageTitle("Privacy Policy");
  //       break;
  //     case "/terms-and-conditions":
  //       setPageTitle("Terms and Conditions");
  //       break;
  //     case "/cookie-policy":
  //       setPageTitle("Cookie Policy");
  //       break;
  //     case "/social-media-links":
  //       setPageTitle("Social Media Links");
  //       break;
  //     // case "/pdfs":
  //     //   setPageTitle("PDFs");
  //     //   break;
  //     case "/faqs":
  //       setPageTitle("FAQs");
  //       break;
  //     case "/sevak-army":
  //       setPageTitle("Sevak Army");
  //       break;
  //     case "/life-saver-army":
  //       setPageTitle("Life Saver Army");
  //       break;
  //     case "/my-food-checker":
  //       setPageTitle("My Food Checker");
  //       break;
  //     case "/mind-unload":
  //       setPageTitle("Mind Unload");
  //       break;
  //     case "/akshay-netra":
  //       setPageTitle("Akshay Netra");
  //       break;
  //     case "/young-jains":
  //       setPageTitle("Young Jains");
  //       break;
  //     case "/reform-army":
  //       setPageTitle("Reform Army");
  //       break;
  //     case "/pledge-my-organs":
  //       setPageTitle("Pledge My Organs");
  //       break;
  //     // case "/videos":
  //     //   setPageTitle("Videos");
  //     //   break;
  //     case "/volunteer-opportunities":
  //       setPageTitle("Volunteer Opportunities");
  //       break;
  //     case "/donate":
  //       setPageTitle("Donate");
  //       break;
  //     case "/tree-plantation":
  //       setPageTitle("Tree Plantation");
  //       break;
  //     case "/blood-donation":
  //       setPageTitle("Blood Donation");
  //       break;
  //     case "/orphanage-visit":
  //       setPageTitle("Orphanage Visit");
  //       break;
  //     case "/handicap-center-visit":
  //       setPageTitle("Handicap Center Visit");
  //       break;
  //     case "/food-donation-drive":
  //       setPageTitle("Food Donation Drive");
  //     break;
  //      case "/school-activity":
  //       setPageTitle("School & College Outreach");
  //       break;
  //     case "/sticker-campaign":
  //       setPageTitle("Sticker Campaign");
  //       break;
  //     case "/public-awareness-program":
  //       setPageTitle("Public Awareness Program");
  //       break;
  //     case "/newsletter":
  //       setPageTitle("Newsletter");
  //       break;
  //     case "/resources":
  //       setPageTitle("Resources");
  //       break;
  //     default:
  //       setPageTitle("");
  //   }
  // }, [location]);

  return (
    <footer className="footer footer--bg footer--styleOne pt-40 pb-40">
      {/* <Helmet>
        <title>JJFIndia | {pageTitle}</title>
      </Helmet> */}
      <img src={shape} alt="Act for Change" className="footer__shape" />
      <div className="container">
        <div
          className="row align-items-center footer-stylling"
          style={{ flexWrap: "wrap" }}
        >
          <div className="col-6 lg:col-4">
            <div className="footer__logo">
              <a href="/">
                <img src={JjfLogo} width={260} alt="Join the Movement" />
              </a>
            </div>
          </div>

          <div className="col-12">
            <hr className="footer__line" />
          </div>
        </div>
        <div className="row">
          <div className="footer__middle pt-20 pb-20 ps-md-0 ps-sm-3 ps-4">
            <div className="row justify-content-between">
              <div className="col-lg-2 col-md-4 col-sm-6 mt-20">
                <div className="footer__widget">
                  <div className="footer__title">
                    <h2 className="footer__heading text-uppercase text-white">
                      About us
                    </h2>
                  </div>
                  <div className="footer__menu">
                    <ul>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/about-us/who-we-are"
                        >
                          Who We Are?
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/about-us/our-journey"
                        >
                          Our Journey
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/about-us/leadership-team"
                        >
                          Leadership Team
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/impact/success-stories"
                        >
                          Success Stories
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/impact/testimonials"
                        >
                          Testimonials
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/impact/achievements"
                        >
                          Achievements
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/contact-us"
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 mt-20">
                <div className="footer__widget">
                  <div className="footer__title">
                    <h2 className="footer__heading text-uppercase text-white">
                      Support us
                    </h2>
                  </div>
                  <div className="footer__menu">
                    <ul>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/legal-documents"
                        >
                          Legal Documents
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/privacy-policy"
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/terms-and-conditions"
                        >
                          Terms and Conditions
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/cookie-policy"
                        >
                          Cookie Policy
                        </Link>
                      </li>
                      {/* <li>
                        <Link className="linkkk" onClick={ClickHandler} to="/social-media-links">
                          Social Media Links
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/faqs"
                        >
                          FAQs
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/newsletters"
                        >
                          Newsletters
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 mt-20">
                <div className="footer__widget">
                  <div className="footer__title">
                    <h2 className="footer__heading text-uppercase text-white">
                      Our Initiative
                    </h2>
                  </div>
                  <div className="footer__menu">
                    <ul>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/sevak-army"
                        >
                          SevakArmy.com
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/life-saver-army"
                        >
                          LifeSaverArmy.com
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/my-food-checker"
                        >
                          MyFoodChecker.com
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/mind-unload"
                        >
                          MindUnload.com
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/akshay-netra"
                        >
                          AkshayNetra.com
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/young-jains"
                        >
                          YoungJains.com
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/reform-army"
                        >
                          ReformArmy.com
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="linkkk"
                          onClick={ClickHandler}
                          to="/initiatives/pledge-my-organs"
                        >
                          PledgeMyOrgans.com
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-sm-6 mt-20">
                <form
                  action="#"
                  method="post"
                  className="footer__newsletter"
                  onSubmit={handleSubmit}
                >
                  <div className="footer__title">
                    <h2 className="footer__heading text-uppercase text-white">
                      Newsletter
                    </h2>
                  </div>

                  <div className="mb-20">
                    <div className="footer__newsletter__formGroup">
                      <input
                        type="email"
                        className="footer__newsletter__input"
                        placeholder="Email ID"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <input
                        className="footer__newsletter__button"
                        type="submit"
                        value="Subscribe"
                      />
                    </div>
                    {errors.email && (
                      <p className="error-message mt-1">{errors.email}</p>
                    )}
                  </div>

                  <div className="footer__newsletter__formGroup">
                    <input
                      id="agree"
                      type="checkbox"
                      className="footer__newsletter__check form-check-input"
                      checked={isAgreed}
                      onChange={(e) => setIsAgreed(e.target.checked)}
                    />
                    <label
                      className="footer__newsletter__label"
                      htmlFor="agree"
                    >
                      I agree that my submitted data is being collected and
                      stored.
                    </label>
                  </div>
                  {errors.isAgreed && (
                    <p className="error-message mt-1">{errors.isAgreed}</p>
                  )}
                  {errors.submit && (
                    <p className="error-message mt-1">{errors.submit}</p>
                  )}

                  {successMessage && (
                    <div
                      className="success-message mt-3"
                      style={{ fontSize: "20px", color: "#7FB432" }}
                    >
                      {successMessage}
                    </div>
                  )}
                </form>
                <div className="pt-30 justify-content-center">
                  <div className="footer__social itSocial">
                    <ul
                      className="justify-content-start"
                      style={{ flexWrap: "wrap" }}
                    >                     
                      
                      <li className="">
                        <a
                          className="instagram"
                          href="https://www.instagram.com/TeamJJFIndia/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li className="">
                        <a
                          className="linkedin"
                          href="https://www.linkedin.com/company/TeamJJFIndia/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li className="">
                        <a
                          onClick={ClickHandler}
                          className="facebook"
                          href="https://www.facebook.com/TeamJJFIndia/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="">
                        <a
                          className=""
                          href="https://www.youtube.com/@TeamJJFIndia/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 20 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8 10L13.19 7L8 4V10ZM19.56 2.17C19.69 2.64 19.78 3.27 19.84 4.07C19.91 4.87 19.94 5.56 19.94 6.16L20 7C20 9.19 19.84 10.8 19.56 11.83C19.31 12.73 18.73 13.31 17.83 13.56C17.36 13.69 16.5 13.78 15.18 13.84C13.88 13.91 12.69 13.94 11.59 13.94L10 14C5.81 14 3.2 13.84 2.17 13.56C1.27 13.31 0.69 12.73 0.44 11.83C0.31 11.36 0.22 10.73 0.16 9.93C0.0900001 9.13 0.0599999 8.44 0.0599999 7.84L0 7C0 4.81 0.16 3.2 0.44 2.17C0.69 1.27 1.27 0.69 2.17 0.44C2.64 0.31 3.5 0.22 4.82 0.16C6.12 0.0899998 7.31 0.0599999 8.41 0.0599999L10 0C14.19 0 16.8 0.16 17.83 0.44C18.73 0.69 19.31 1.27 19.56 2.17Z"
                                fill="white"
                              />
                            </svg>
                          </i>
                        </a>
                      </li>
                      <li className="">
                        <a
                          className="twitter"
                          href="https://x.com/TeamJJFIndia/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0)">
                                <mask
                                  id="mask0"
                                  style={{ maskType: "luminance" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="14"
                                  height="14"
                                >
                                  <path d="M0 0H14V14H0V0Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0)">
                                  <path
                                    d="M11.025 0.65625H13.172L8.482 6.03025L14 13.3442H9.68L6.294 8.90925L2.424 13.3442H0.275L5.291 7.59425L0 0.65725H4.43L7.486 4.71025L11.025 0.65625ZM10.27 12.0562H11.46L3.78 1.87725H2.504L10.27 12.0562Z"
                                    fill="white"
                                  />
                                </g>
                              </g>
                              <defs>
                                <clipPath id="clip0">
                                  <rect width="14" height="14" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </i>
                        </a>
                      </li>
                        <li className="">
                        <a
                          className="threads"
                          href="https://www.threads.net/@TeamJJFIndia/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5.44962 4.623C6.99662 2.974 9.23963 2 12.0166 2C16.5816 2 19.6086 4.631 20.5666 8.277C20.634 8.5336 20.5967 8.80644 20.4629 9.03552C20.329 9.2646 20.1097 9.43113 19.8531 9.4985C19.5965 9.56586 19.3237 9.52854 19.0946 9.39473C18.8655 9.26092 18.699 9.0416 18.6316 8.785C17.9046 6.022 15.6756 4 12.0156 4C9.72962 4 8.03562 4.789 6.90962 5.99C5.77362 7.202 5.14062 8.913 5.14062 10.875V13.125C5.14062 15.087 5.77362 16.798 6.90962 18.009C8.03562 19.212 9.72962 20 12.0156 20C13.6706 20 14.9836 19.616 15.9916 18.995C17.0066 18.37 17.6116 17.541 17.7816 16.59C17.9766 15.494 17.7366 14.742 17.3236 14.199C17.0971 13.9068 16.8217 13.6561 16.5096 13.458C16.3746 14.207 16.1336 14.914 15.7696 15.468C14.4276 17.507 11.8616 17.682 10.1696 17.007C9.25363 16.642 8.46863 15.643 8.22463 14.572C8.07648 13.9581 8.12583 13.3132 8.36563 12.729C8.63063 12.093 9.12163 11.551 9.82063 11.139C10.5126 10.73 11.5406 10.542 12.5596 10.514C13.1736 10.497 13.8396 10.538 14.5096 10.647C14.3696 9.997 14.1326 9.512 13.8656 9.263C13.3816 8.813 12.5796 8.496 11.7756 8.501C10.9986 8.507 10.3396 8.806 9.94563 9.436C9.80506 9.6609 9.58091 9.82076 9.32248 9.88039C9.06406 9.94003 8.79253 9.89456 8.56763 9.754C8.34272 9.61343 8.18287 9.38929 8.12323 9.13086C8.0636 8.87244 8.10906 8.6009 8.24963 8.376C9.08663 7.038 10.4656 6.511 11.7626 6.501C13.0326 6.492 14.3406 6.973 15.2286 7.799C16.1266 8.635 16.5126 10.006 16.6126 11.253C17.4866 11.634 18.3126 12.193 18.9176 12.99C19.6986 14.02 20.0346 15.348 19.7506 16.941C19.4606 18.565 18.4356 19.839 17.0406 20.698C15.6726 21.54 13.9846 22 12.0156 22C9.23962 22 6.99563 21.026 5.45063 19.377C3.91463 17.739 3.14062 15.513 3.14062 13.125V10.875C3.14062 8.487 3.91463 6.261 5.45063 4.623H5.44962ZM14.5996 12.7C13.9474 12.5593 13.2807 12.4969 12.6136 12.514C11.7226 12.538 11.0976 12.707 10.8366 12.861C10.4526 13.088 10.2866 13.319 10.2126 13.498C10.1337 13.6987 10.1204 13.9193 10.1746 14.128C10.2966 14.664 10.6996 15.066 10.9106 15.149C12.0366 15.599 13.4456 15.361 14.0986 14.369C14.3336 14.011 14.5206 13.409 14.5986 12.7H14.5996Z"
                                fill="white"
                              />
                            </svg>
                          </i>
                        </a>
                      </li>
                      {/* <li className="">
                        <a
                          className="pinterest"
                          href="https://www.quora.com/profile/TeamJJFIndia"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.94 17.46H19.83C19.77 17.98 19.43 18.63 18.58 18.63C17.8 18.63 17.24 18.09 16.7 17.27C17.5917 16.5883 18.3126 15.7085 18.8055 14.7001C19.2984 13.6917 19.5499 12.5824 19.54 11.46C19.54 7 15.86 4 12.01 4C8.21 4 4.5 7.03 4.5 11.47C4.5 15.87 8.21 18.9 12.01 18.9C12.67 18.9 13.33 18.81 13.96 18.64C14.7 19.91 15.69 21 17.56 21C20.66 21 21.01 18.14 20.94 17.46ZM15.49 15.28C14.76 14.17 13.83 13.3 12.03 13.3C10.87 13.3 9.97 13.68 9.41 14.16L9.87 15.08C10.11 14.97 10.36 14.93 10.62 14.93C11.97 14.93 12.66 16.1 13.25 17.26C12.87 17.37 12.46 17.42 12.01 17.42C9.16 17.42 7.93 15.41 7.93 11.47C7.93 7.51 9.16 5.48 12.01 5.48C14.9 5.48 16.14 7.51 16.14 11.47C16.13 13.05 15.93 14.33 15.49 15.28Z"
                                fill="white"
                              />
                            </svg>
                          </i>
                        </a>
                      </li> */}
                      <li className="">
                        <a
                          className="pinterest"
                          href="https://in.pinterest.com/TeamJJFIndia/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-pinterest-p"></i>
                        </a>
                      </li>
                      
                      {/* <li className="">
                      <a
                        className="pinterest"
                        href="https://www.reddit.com/user/TeamJJFIndia/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="">
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M25.4172 12V12.03C25.4172 12.573 25.2612 13.08 24.9922 13.509L24.9992 13.497C24.7301 13.9336 24.3451 14.287 23.8872 14.518L23.8712 14.525C23.9792 14.928 24.0412 15.39 24.0412 15.868V15.886C24.0339 17.3827 23.496 18.8274 22.5232 19.965L22.5302 19.956C21.4436 21.2552 20.0512 22.2641 18.4782 22.892L18.4092 22.916C16.7742 23.602 14.8742 24.001 12.8802 24.001L12.7272 24H12.7352L12.5892 24.001C10.5982 24.001 8.70115 23.602 6.97215 22.88L7.06815 22.916C5.47729 22.2915 4.06762 21.2795 2.96715 19.972L2.95415 19.956C1.98567 18.8207 1.45069 17.3791 1.44415 15.887V15.88C1.44415 15.41 1.50015 14.952 1.60515 14.514L1.59715 14.554C1.12463 14.3236 0.724675 13.9676 0.441152 13.525L0.434152 13.514C0.145345 13.0627 -0.0074069 12.5377 -0.00584755 12.002C-0.00584755 11.225 0.308152 10.521 0.817152 10.011C1.06978 9.74818 1.37292 9.53919 1.70837 9.39656C2.04382 9.25393 2.40464 9.18059 2.76915 9.18095H2.81915H2.81615H2.85515C3.65415 9.18095 4.37415 9.52395 4.87415 10.07L4.87615 10.072C7.02636 8.59919 9.56605 7.79927 12.1722 7.77395H12.1802L13.8262 0.383953C13.8548 0.26135 13.9306 0.154983 14.0372 0.0879531L14.0392 0.0869531C14.0926 0.0493934 14.1534 0.0236361 14.2175 0.0113942C14.2816 -0.000847621 14.3477 0.000706456 14.4112 0.0159531L14.4082 0.0149531L19.6422 1.16395C19.8162 0.810953 20.0772 0.524953 20.3992 0.325953L20.4082 0.320953C20.7272 0.120953 21.1152 0.00195312 21.5312 0.00195312C22.1162 0.00195312 22.6472 0.236953 23.0322 0.618953C23.4172 0.987953 23.6562 1.50695 23.6562 2.08195V2.11795V2.11595V2.14595C23.6562 2.72395 23.4172 3.24595 23.0322 3.61795L23.0312 3.61895C22.8342 3.81722 22.5998 3.97446 22.3416 4.08157C22.0835 4.18868 21.8066 4.24353 21.5272 4.24295C20.9662 4.24345 20.4279 4.02158 20.0302 3.62595C19.8346 3.43623 19.6792 3.20912 19.5732 2.95813C19.4672 2.70715 19.4128 2.4374 19.4132 2.16495V2.12695V2.12895L14.6752 1.07895L13.2002 7.77295C15.9472 7.79295 18.4932 8.63795 20.6072 10.073L20.5602 10.043C20.8227 9.76904 21.138 9.55117 21.4871 9.4025C21.8362 9.25383 22.2117 9.17744 22.5912 9.17795C23.3712 9.17795 24.0772 9.49495 24.5882 10.008C25.0972 10.504 25.4132 11.197 25.4132 11.963V12.002V12H25.4172ZM5.92815 14.822V14.854C5.92815 15.43 6.16415 15.951 6.54515 16.325C6.73409 16.5226 6.96118 16.6797 7.21265 16.787C7.46413 16.8943 7.73476 16.9494 8.00815 16.949H8.04415H8.04215C8.60637 16.9484 9.14733 16.7241 9.54629 16.3251C9.94525 15.9261 10.1696 15.3852 10.1702 14.821V14.787C10.1702 14.212 9.93115 13.693 9.54615 13.325L9.54515 13.324C9.35346 13.1283 9.12458 12.9729 8.87196 12.8669C8.61934 12.7609 8.34809 12.7066 8.07415 12.707H8.04015H8.04215C7.48311 12.7117 6.94828 12.9357 6.55287 13.331C6.15746 13.7262 5.93312 14.2609 5.92815 14.82V14.822ZM17.4172 19.858C17.4667 19.8101 17.5061 19.7528 17.533 19.6894C17.5599 19.626 17.5738 19.5578 17.5738 19.489C17.5738 19.4201 17.5599 19.3519 17.533 19.2885C17.5061 19.2251 17.4667 19.1678 17.4172 19.12C17.3726 19.0748 17.3195 19.0389 17.261 19.0145C17.2024 18.9901 17.1396 18.9777 17.0762 18.978H17.0622H17.0552C16.9212 18.9778 16.7921 19.0285 16.6942 19.12C16.2202 19.5614 15.6343 19.8644 15.0002 19.996L14.9772 20C13.4658 20.3831 11.8821 20.3783 10.3732 19.986L10.4372 20C9.79292 19.8709 9.19714 19.5655 8.71615 19.118L8.71815 19.12C8.62031 19.0284 8.49118 18.9776 8.35715 18.978H8.33815C8.27473 18.9778 8.21193 18.9903 8.15338 19.0147C8.09484 19.0391 8.04173 19.0748 7.99715 19.12C7.94694 19.1638 7.9067 19.2179 7.8791 19.2787C7.85151 19.3394 7.8372 19.4053 7.83715 19.472V19.486C7.83715 19.632 7.89815 19.764 7.99715 19.858C8.46613 20.2997 9.0308 20.6273 9.64715 20.815L9.67715 20.823C10.2255 21.022 10.7938 21.1608 11.3722 21.237L11.4152 21.242C11.8592 21.2846 12.2892 21.306 12.7052 21.306C13.1212 21.306 13.5512 21.2846 13.9952 21.242C14.6081 21.1629 15.2104 21.0164 15.7912 20.805L15.7332 20.824C16.3624 20.6375 16.9394 20.3068 17.4182 19.858L17.4162 19.86L17.4172 19.858ZM17.3752 16.95H17.4092C17.9842 16.95 18.5032 16.711 18.8712 16.326L18.8722 16.325C19.2532 15.951 19.4892 15.43 19.4892 14.854V14.82V14.822C19.4845 14.2629 19.2604 13.7281 18.8651 13.3327C18.4699 12.9373 17.9352 12.7129 17.3762 12.708H17.3432C16.7672 12.708 16.2462 12.944 15.8722 13.325C15.6746 13.5139 15.5174 13.741 15.4101 13.9925C15.3028 14.2439 15.2477 14.5146 15.2482 14.788V14.824V14.822C15.2487 15.3862 15.4731 15.9271 15.872 16.3261C16.271 16.7251 16.8119 16.9494 17.3762 16.95H17.3752Z"
                              fill="white"
                            />
                          </svg>
                        </i>
                      </a>
                    </li> */}
                      <li className="">
                        <a
                          className="medium"
                          href="https://medium.com/@TeamJJFIndia"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8 6C9.5913 6 11.1174 6.63214 12.2426 7.75736C13.3679 8.88258 14 10.4087 14 12C14 13.5913 13.3679 15.1174 12.2426 16.2426C11.1174 17.3679 9.5913 18 8 18C6.4087 18 4.88258 17.3679 3.75736 16.2426C2.63214 15.1174 2 13.5913 2 12C2 10.4087 2.63214 8.88258 3.75736 7.75736C4.88258 6.63214 6.4087 6 8 6ZM17 7C18.5 7 19.5 9.239 19.5 12C19.5 14.761 18.5 17 17 17C15.5 17 14.5 14.761 14.5 12C14.5 9.239 15.5 7 17 7ZM21 7.5C21.38 7.5 21.712 8.327 21.88 9.746L21.927 10.189L21.946 10.424L21.976 10.918L21.986 11.177L21.998 11.718L22 12L21.998 12.282L21.986 12.823L21.976 13.083L21.946 13.576L21.926 13.811L21.881 14.254C21.712 15.674 21.381 16.5 21 16.5C20.62 16.5 20.288 15.673 20.12 14.254L20.073 13.811L20.054 13.576L20.024 13.082L20.014 12.823L20.002 12.282V11.718L20.014 11.177L20.024 10.917L20.054 10.424L20.074 10.189L20.119 9.746C20.288 8.326 20.619 7.5 21 7.5Z"
                                fill="white"
                              />
                            </svg>
                          </i>
                        </a>
                      </li>
                      {/* <li className="">
                        <a
                          className="whatsapp"
                          href="https://wa.me/919552895289"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-whatsapp"></i>
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="footer__bottom">
            <div className="row">
              <div className="col-12">
                <hr className="footer__line" />
              </div>
              <div className="col mb-20">
                <div className="footer__copyright pt-20">
                  <p className="footer__copyright__text mb-0 text-center44">
                    © 2017 - 2025{" "}
                    <a
                      className="footer-link-website"
                      href="https://jjfindia.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ paddingLeft: "5px", paddingRight: "5px" }}
                    >
                      {" "}
                      Jainam Jivika Foundation,
                    </a>{" "}
                    All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
